export default class Environment {
  static _environment(): string {
    const hostname = window.location.hostname;

    if (hostname === 'localhost') {
      return 'local';
    } else if (hostname.endsWith('dev.naic.org')) {
      return 'dev';
    } else if (hostname.endsWith('qa.naic.org')) {
      return 'qa';
    } else if (hostname.endsWith('prod.naic.org')) {
      return 'prod';
    } else {
      return '';
    }
  }

  static API_URL(): string {
    if (this._environment() === 'local') {
      return 'http://localhost:8080';
    } else if (this._environment() === 'dev') {
      return 'https://enhanced-profiles-service.dev.naic.org';
    } else if (this._environment() === 'qa') {
      return 'https://enhanced-profiles-service.qa.naic.org';
    } else if (this._environment() === 'prod') {
      return 'https://enhanced-profiles-service.prod.naic.org';
    }

    return '';
  }

  static AUTH_URL(): string {
    if (
      this._environment() === 'local' ||
      this._environment() === 'dev' ||
      this._environment() === 'qa'
    ) {
      return 'https://authenticate-nonprod.naic.org';
    } else if (this._environment() === 'prod') {
      return 'https://authenticate.naic.org';
    }

    return '';
  }

  static APP_URL(): string {
    if (this._environment() === 'local') {
      return 'http://localhost:4200';
    } else if (this._environment() === 'dev') {
      return 'https://enhanced-profiles-web.dev.naic.org';
    } else if (this._environment() === 'qa') {
      return 'https://enhanced-profiles-web.qa.naic.org';
    } else if (this._environment() === 'prod') {
      return 'https://enhanced-profiles-web.prod.naic.org';
    }

    return '';
  }

  static ISITE_URL(): string {
    if (this._environment() === 'local' || this._environment() === 'dev') {
      return 'https://isiteplus.dev.naic.org';
    } else if (this._environment() === 'qa') {
      return 'https://isiteplus.qa.naic.org';
    } else if (this._environment() === 'prod') {
      return 'https://isiteplus.naic.org';
    }

    return '';
  }

  static CLOUDAPPS_URL(): string {
    if (this._environment() === 'local' || this._environment() === 'dev') {
      return 'https://cloudapps-dev.naic.org';
    } else if (this._environment() === 'qa') {
      return 'https://cloudapps-qa.naic.org';
    } else if (this._environment() === 'prod') {
      return 'https://cloudapps.naic.org';
    }

    return '';
  }

  static EAPPS_URL(): string {
    if (this._environment() === 'local' || this._environment() === 'dev') {
      return 'https://eapps.dev.naic.org';
    } else if (this._environment() === 'qa') {
      return 'https://eapps.qa.naic.org';
    } else if (this._environment() === 'prod') {
      return 'https://eapps.naic.org';
    }

    return '';
  }

  static CLIENT_ID(): string {
    if (
      this._environment() === 'local' ||
      this._environment() === 'dev' ||
      this._environment() === 'qa'
    ) {
      return '0oa2e38ey0mj5ZFKJ0h8';
    } else if (this._environment() === 'prod') {
      return '0oarcmn6owk6SF3IA4x7';
    }

    return '';
  }

  static REDIRECT_URL(): string {
    if (this._environment() === 'local') {
      return 'http://localhost:4200/callback';
    } else if (this._environment() === 'dev') {
      return 'https://enhanced-profiles-web.dev.naic.org';
    } else if (this._environment() === 'qa') {
      return 'https://enhanced-profiles-web.qa.naic.org';
    } else if (this._environment() === 'prod') {
      return 'https://enhanced-profiles-web.prod.naic.org';
    }

    return '';
  }
}
